import { styled } from '@slal/ui';
import { Field } from '~/components';

export const StyledField = styled(Field)`
    label {
        font-weight: 400;
    }
    span {
        font-size: ${({ theme }) => theme.fontSizes[4]};
        color: ${({ theme }) => theme.colors.neutral__light__70};
        padding: ${({ theme }) => theme.space[3]} 0;
    }
`;
